import service from "@/utils/request";

export function getWareOutPage(params) {
  return service.get("/uic-system/api_hf/wareout/page1", {
    params,
  });
}

export function getWareOutOrderPage(params) {
  return service.get("/uic-system/wareout/page", {
    params: {
      source: 0,
      ...params,
    },
  });
}

/** 扫码出库：按送货单号查询送货计划单 */
export function getSendPlanBySendNo(sendNo) {
  return service.get("/uic-system_hf/sendplan/selectSendNo", {
    params: { sendNo },
  });
}

export function batchWareOut(data) {
  return service.post("/uic-system_hf/wareout/batch/out/async", data);
}

export function getWareOutPrintPage(params) {
  return service.get("/uic-system/api_hf/wareout/page", {
    params,
  });
}

export function getResourceAndNoPlsNo(data, config = {}) {
  return service.post("/uic-system/api_hf/wareout/GetResourceAndNoPlsNo", data, config);
}

export function getReturnWareOutPage(params) {
  const requestParams = {
    wareOutStatus: params?.wareOutStatus || 0,
    wareOutType: 1,
    current: params?.current || 1,
    size: params?.size || 20,
  };

  if (
    params?.supplierId !== undefined &&
    params?.supplierId !== null &&
    params?.supplierId !== ""
  ) {
    requestParams.supplierId = params.supplierId;
  }

  return service.get("/uic-system/api_hf/wareout/page1", {
    params: {
      ...requestParams,
    },
  });
}

export function getWareOutDetail(id) {
  return service.get("/uic-system/api/wareout/detail", {
    params: { id },
  });
}

export function getWareOutOrderDetail(id) {
  return service.get("/uic-system/wareout/getDetail", {
    params: { id },
  });
}

/** 扫码出库：送货计划单详情 */
export function getSendPlanDetail(id) {
  return service.get("/uic-system_hf/sendplan/detail", {
    params: { id },
  });
}

export function getWareOutDetailHf(id, isBad) {
  return service.get("/uic-system/api_hf/WareOut/detail", {
    params: {
      id,
      ...(isBad === undefined || isBad === null ? {} : { isBad }),
    },
  });
}

export function immediateWareOutHf(data) {
  return service.post("/uic-system_hf/wareout/immediate-wareout2", data);
}

export function immediateWareOutV2(data) {
  return service.post("/uic-system_hf/wareout/immediate-wareout-v2", data);
}

export function confirmWareOut(data) {
  return service.post("/uic-system/api/wareout/confirm", data);
}

/** 扫码校验完成：按出库单 ID 确认 */
export function confirmWareOutByIds(ids) {
  return service.post("/uic-system/wareout/confirm", null, {
    params: { ids },
  });
}

/** 扫码出库：单条确认出库 */
export function confirmWareOutSingle(data) {
  return service.post("/uic-system/wareout/single/confirm", data);
}

/** 扫码出库：送货计划单校验完成并自动分配 */
export function distributeSendPlanAuto(data) {
  return service.post("/uic-system_hf/sendplan/distribute/auto", data);
}

export function updatePlanStatus(ids) {
  return service.post("/uic-system/api_hf/wareout/updatePlanStatus", null, {
    params: { ids },
  });
}

export function updateIsPrint(ids) {
  return service.post("/uic-system/api_hf/wareout/updateIsPrint", null, {
    params: { ids },
  });
}

export function getWareOutId(wareOutId) {
  return service.get("/uic-system_hf/wareoutdetailrecord/getWareOutId", {
    params: { wareOutId },
  });
}
